rescindRegister = function (id) {
    event.preventDefault();
    if (confirm("Deseja recindir esse contrato?")) {
        document.getElementById(id).submit();
    }
};

renewRegister = function (id) {
    event.preventDefault();
    if (confirm("Deseja renovar esse contrato?")) {
        document.getElementById(id).submit();
    }
};



// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-rescind-contract.js